/*
 * @author        zach.william@zumper.com (Zach William)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   setSavedCustomMessage.ts
 */

import { event, toTraktorEventName } from '@zcode-ui/web-zumper-integrations'
import { localStorageSingleton } from '@zcode/nr-utils'
import type { Dispatch } from 'redux'
import type { GetState } from '../../../../modules/types'
import {
  SAVED_CUSTOM_MESSAGE_LOCALSTORAGE_KEY,
  SAVED_CUSTOM_MESSAGE_TRAKTOR_ACTIONS,
  SAVED_CUSTOM_MESSAGE_TRAKTOR_CATEGORY,
} from '../../constants'
import { resetState } from '../actions'
import { selectCustomMessageChecked } from '../selectors'

export const setSavedCustomMessage =
  (message: string | undefined) => (dispatch: Dispatch, getState: GetState) => {
    const customMessageChecked = selectCustomMessageChecked(getState())

    if (!message) {
      localStorageSingleton.del(SAVED_CUSTOM_MESSAGE_LOCALSTORAGE_KEY)
      dispatch(resetState())
      return
    }

    if (customMessageChecked) {
      localStorageSingleton.setx(SAVED_CUSTOM_MESSAGE_LOCALSTORAGE_KEY, message, 7)
    }

    dispatch(
      event({
        name: toTraktorEventName(SAVED_CUSTOM_MESSAGE_TRAKTOR_CATEGORY),
        // @ts-expect-error props should be an object, not a string
        props: SAVED_CUSTOM_MESSAGE_TRAKTOR_ACTIONS.SAVE_MESSAGE,
      })
    )
  }
